const selectors$c = {
  productMedia: '.product__media',
  productImage: '[data-product-image]',
  mediaId: 'data-media-id',
  // Zoom in inner
  zoomInner: '[data-zoom-inner]',
};

/** Zoom in inner 
 * @param {HTMLElement} container
*/
function productPhotoInnerZoom(container, json) {
  /** Zoom in by mouse position 
   * @param {HTMLElement} overlay
   * @param {String} src
   * @param {String} clientX
   * @param {String} clientY
   */
  function zoomIn(overlay, src, clientX, clientY) {
    const { left, top, width, height } = overlay.getBoundingClientRect();
    const x = clientX - left;
    const y = clientY - top;
    const bgPosX = x / width * 100;
    const bgPosY = y / height * 100;
    overlay.style.backgroundImage = `url('${src}')`;
    overlay.style.backgroundPosition = `${bgPosX}% ${bgPosY}%`;
  }
  function cancelZoomIn(overlay) {
    const media = overlay.closest(selectors$c.productMedia);
    media.classList.remove("zoom--zooming");
    overlay.classList.remove("active");
    overlay.style.backgroundImage = `none`;
    overlay.style.backgroundPosition = "initial";
  }
  // Loading image in background
  function loadingImage(overlay, src) {
    const overlayImage = document.createElement('img');
    const media = overlay.closest(selectors$c.productMedia);
    overlayImage.setAttribute('src', `${src}`);
    // Starting loading
    media.classList.add("zoom--loading");
    overlayImage.onload = () => {
      // Finished loading
      media.classList.remove("zoom--loading");
      media.classList.add("zoom--zooming");
    };
  }
  // Set events
  const onClick = (event) => {
    const zoomInner = event.target;
    const productImage = zoomInner.closest(selectors$c.productMedia).querySelector(selectors$c.productImage);
    const imageSrc = productImage.getAttribute("data-zoom-src") ?? productImage.src;
    const media = zoomInner.closest(selectors$c.productMedia);
    if (!productImage) return;
    if (zoomInner.classList.contains("active")) {
      cancelZoomIn(zoomInner);
    } else {
      zoomInner.classList.add("active");
      loadingImage(zoomInner, imageSrc);
      zoomIn(zoomInner, imageSrc, event.clientX, event.clientY);
    }
  }
  const onMouseMove = (event) => {
    const zoomInner = event.target;
    if (!zoomInner.classList.contains("active")) return;
    const productImage = zoomInner.closest(selectors$c.productMedia).querySelector(selectors$c.productImage);
    const imageSrc = productImage.getAttribute("data-zoom-src") ?? productImage.src;
    const media = zoomInner.closest(selectors$c.productMedia);
    zoomIn(zoomInner, imageSrc, event.clientX, event.clientY);
  }
  const onMouseLeave = (event) => {
    const zoomInner = event.target;
    const media = zoomInner.closest(selectors$c.productMedia);
    if (zoomInner.classList.contains("active") && !media.classList.contains("zoom--loading")) {
      cancelZoomIn(zoomInner);
    }
  }
  const triggers = container.querySelectorAll(selectors$c.zoomInner);
  for (const zoomInner of triggers) {
    zoomInner.addEventListener('click', onClick);
    zoomInner.addEventListener('mousemove', onMouseMove);
    zoomInner.addEventListener('mouseleave', onMouseLeave);
  }
  return {
    destroy: () => {
      for (const zoomInner of triggers) {
        zoomInner.removeEventListener('click', onClick);
        zoomInner.removeEventListener('mousemove', onMouseMove);
        zoomInner.removeEventListener('mouseleave', onMouseLeave);
      }
    }
  }
}

if (!customElements.get('product-layout-b-content')) {
  customElements.define('product-layout-b-content', class ProductLayoutBContent extends HTMLElement {
    currentVariantId = undefined;
    swatchSwipers = [];
    _syncingToLayoutA = false;
    _syncOptionsRAF = null;

    constructor() {
      super();

      this.section = this.closest('.shopify-section')?.querySelector('[data-section-type="product"]');
      this.layoutContentA = this.closest('.shopify-section')?.querySelector('.product-page');
      this.quantityInputA = this.section?.querySelector('[data-quantity-input]');
      this.quantityInputB = this.querySelector('[data-quantity-input]');
      this.addToCartButtonB = this.querySelector('[data-add-to-cart-button]');
      this.sectionMediaListWrapper = this.section?.querySelector('[data-product-slideshow]');
      this.airlineCompatibilityButton = this.section?.querySelector('[data-button-airline-sizing]');
      this.seeMoreImagesButton = this.section?.querySelector('[data-see-more-images-button]');
      this.seeMoreImagesButtonCount = this.seeMoreImagesButton?.querySelector('[data-see-more-images-count]');

      this.layoutBranch = this.getAttribute('data-layout-b-branch') ?? '1';
      this.show2MainMediaInGrid = this.getAttribute('data-show-2-main-media-in-grid') === 'true';
      this.hiddenGallerySlides = this.show2MainMediaInGrid ? 0 : 2;

      this._onVariantChange = this.onVariantChange.bind(this);
      this._onOptionChange = this.onOptionChange.bind(this);
      this._onQuantityChange = this.onQuantityChange.bind(this);
      this._onSeeMoreImagesClick = this.onSeeMoreImagesClick.bind(this);

      this.currentVariantId = Number(this.getAttribute('data-current-variant-id'));

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const sectionVisableMediaList = this.hideSectionGalleryVisableMedia();
          this.updateHiddenMoreMedia(sectionVisableMediaList);
          this.section.classList.add('initialized');
        });
      });
    }

    /**
     * @description 隐藏 section 橱窗图中的前 slides 个 Media
     * @param {number} slides 
     */
    hideSectionGalleryVisableMedia(slides = this.hiddenGallerySlides) {
      const sectionVisableMediaList = this.layoutContentA.querySelectorAll('[data-media-slide]:not(.hide)');
      for (let i = 0; i < slides; i++) {
        sectionVisableMediaList[i].classList.add('hidden-767-up');
      }
      return sectionVisableMediaList;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      document.addEventListener('theme:variant:change', this._onVariantChange);
      this.addEventListener('change', this._onOptionChange);
      this.quantityInputA.addEventListener('change', this._onQuantityChange);
      this.seeMoreImagesButton?.addEventListener('click', this._onSeeMoreImagesClick);
      this.createSwatchSwiper();
      new window.theme.modules.ProductAddButton(this.querySelector('[data-add-action-wrapper]'));
    }

    onQuantityChange(event) {
      this.quantityInputB.value = this.quantityInputA.value;
      this.quantityInputB.dispatchEvent(new CustomEvent('change'));
    }

    destroy() {
      document.removeEventListener('theme:variant:change', this._onVariantChange);
      this.removeEventListener('change', this._onOptionChange);
      this.quantityInputA.removeEventListener('change', this._onQuantityChange);
      this.seeMoreImagesButton?.removeEventListener('click', this._onSeeMoreImagesClick);
      if (this._syncOptionsRAF) {
        cancelAnimationFrame(this._syncOptionsRAF);
        this._syncOptionsRAF = null;
      }
      for (const swiper of this.swatchSwipers) {
        swiper.destroy(true, true);
      }
      this.swatchSwipers = [];
    }

    /**
     * @description 将 B 布局当前全部选项同步到主模块（layout A），避免 rebuildOptions 自动切换颜色后只同步单个选项导致中间态覆盖 B
     */
    syncAllOptionsToLayoutA() {
      const optionWrappers = this.querySelectorAll('[data-option-position]');
      if (!optionWrappers.length || !this.layoutContentA) return;

      let lastChangedInput = null;

      for (const wrapper of optionWrappers) {
        const optionPosition = wrapper.getAttribute('data-option-position');
        const checkedInput = wrapper.querySelector('input[type="radio"]:checked');
        if (!checkedInput) continue;

        const optionInput = this.layoutContentA.querySelector(
          `[data-option-position="${optionPosition}"] input[type="radio"][value="${CSS.escape(checkedInput.value)}"]`
        );
        if (optionInput && !optionInput.checked) {
          optionInput.checked = true;
          lastChangedInput = optionInput;
        }
      }

      if (!lastChangedInput) return;

      this._syncingToLayoutA = true;
      lastChangedInput.dispatchEvent(new Event('change', { bubbles: true }));
      requestAnimationFrame(() => {
        this._syncingToLayoutA = false;
      });
    }

    /**
     * @description 点击色块时，若该滑块未完全处于容器可视区内，则滚动至接近中间位置
     * @param {import('swiper').Swiper} swiper
     * @param {MouseEvent} event
     */
    scrollSwatchSlideIntoViewIfNeeded(swiper, event) {
      const slideClass = swiper.params.slideClass || 'swatch__button';
      const slideEl = event.target?.closest?.(`.${slideClass}`);
      if (!slideEl || !swiper.el.contains(slideEl)) return;

      const containerEl = swiper.el.closest('[data-product-block-variants]') || swiper.el;
      const containerRect = containerEl.getBoundingClientRect();
      const slideRect = slideEl.getBoundingClientRect();
      if (slideRect.left >= containerRect.left && slideRect.right <= containerRect.right) {
        return;
      }

      const viewportWidth = containerEl.clientWidth;
      if (viewportWidth > 0) {
        swiper.el.style.width = `${viewportWidth}px`;
      }
      swiper.updateSize();

      const slideIndex = typeof swiper.getSlideIndex === 'function'
        ? swiper.getSlideIndex(slideEl)
        : Array.from(swiper.slides).indexOf(slideEl);
      if (slideIndex < 0) return;

      const slide = swiper.slides[slideIndex];
      const spaceBetween = swiper.params.spaceBetween ?? 0;
      const slideWidth = slide.offsetWidth + spaceBetween;
      const visibleCount = Math.max(1, Math.floor(viewportWidth / slideWidth));
      const slidesCount = swiper.slides.length;
      const centerOffset = Math.floor((visibleCount - 1) / 2);
      const maxStartIndex = Math.max(0, slidesCount - visibleCount);

      let targetIndex = slideIndex - centerOffset;
      targetIndex = Math.max(0, Math.min(maxStartIndex, targetIndex));

      swiper.slideTo(targetIndex, swiper.params.speed ?? 300);
    }

    createSwatchSwiper() {
      this.swatchSwipers = [];
      const swiperElements = this.querySelectorAll('.selector-wrapper--color .radio__fieldset');
      for (const element of swiperElements) {
        const swiperInstance = new Swiper(element, {
          slidesPerView: 'auto',
          speed: 300,
          observer: true,
          resizeObserver: true,
          observeParents: true,
          wrapperClass: 'radio__inputs--swatch',
          slideClass: 'swatch__button',
          on: {
            click: (swiper, event) => {
              this.scrollSwatchSlideIntoViewIfNeeded(swiper, event);
            }
          }
        });
        this.swatchSwipers.push(swiperInstance);
      }
    }

    /**
     * @description 更新媒体模块的媒体列表
     * @param {import("@/src/types/shopify").ShopifyVariant} variant 
     */
    hanldeUpdateMedia(variant) {
      if (this.destroyProductPhotoInnerZoom) this.destroyProductPhotoInnerZoom();
      const sectionVisableMediaList = this.layoutContentA.querySelectorAll('[data-media-slide]:not(.hide)');
      const bLayoutMediaList = this.querySelectorAll('[data-media-slide]');
      for (let i = 0; i < 2; i++) {
        const media = bLayoutMediaList[i];
        const sectionVisableMedia = sectionVisableMediaList[i];
        if (media && sectionVisableMedia) {
          sectionVisableMedia.classList.remove('product__media--current-first'); // 先提前移除该类名，后面的函数需要再添加回来
          sectionVisableMedia.classList.remove('hidden-767-up');
          media.outerHTML = sectionVisableMedia.outerHTML;
          if (!this.show2MainMediaInGrid) {
            sectionVisableMedia.classList.add('hidden-767-up');
          }
        }
      }
      this.destroyProductPhotoInnerZoom = productPhotoInnerZoom(this).destroy;

      this.updateHiddenMoreMedia(sectionVisableMediaList);

      this.updateSectionFirstMediaAspectRatio(sectionVisableMediaList);
    }

    /**
     * @description 橱窗中实际展示的媒体超过 6 张时进入「隐藏更多图片」模式；≤6 张则退出该模式。
     * 不计入 hideSectionGalleryVisableMedia 隐藏的前 slides 张。
     * 只有 B 模板的 Branch 2 需要隐藏更多图片
     * @param {NodeListOf<Element>} sectionVisableMediaList 当前变体可见的媒体（含已被 hidden-767-up 的前 slides 张）
     * @param {number} hiddenGallerySlides 橱窗中已隐藏、不计入阈值的前几张；开启 show_2_main_media_in_grid 时为 0
     */
    updateHiddenMoreMedia(sectionVisableMediaList, hiddenGallerySlides = this.hiddenGallerySlides) {
      if (this.layoutBranch != '2') return;

      this.clearHiddenMoreMedia();
      if (!this.sectionMediaListWrapper || !sectionVisableMediaList) return;

      const galleryMediaCount = sectionVisableMediaList.length - hiddenGallerySlides;
      if (galleryMediaCount <= 6) return;

      this.sectionMediaListWrapper.classList.add('product__grid-media--hidden-more');

      for (let i = hiddenGallerySlides + 6; i < sectionVisableMediaList.length; i++) {
        sectionVisableMediaList[i].classList.add('product__media--hidden-more');
      }

      if (this.seeMoreImagesButtonCount) {
        this.seeMoreImagesButtonCount.textContent = (galleryMediaCount - 6).toString();
      }
    }

    /**
     * @description 退出「隐藏更多图片」模式
     */
    clearHiddenMoreMedia() {
      this.sectionMediaListWrapper?.classList.remove('product__grid-media--hidden-more');
      const hiddenMoreMedia = this.sectionMediaListWrapper?.querySelectorAll('.product__media--hidden-more') ?? [];
      for (const media of hiddenMoreMedia) {
        media.classList.remove('product__media--hidden-more');
      }
    }

    onSeeMoreImagesClick() {
      this.clearHiddenMoreMedia();
    }

    /**
     * @description 更新 section 中第一张媒体的比例，放到 section 的 css variable 中，并为首张媒体添加特定类名撑开更高高度，用于给 Airline Compatibility Guide 按钮定位和撑开更大高度。
     * @param {NodeListOf<Element>} sectionVisableMediaList 当前变体可见的媒体（含已被 hidden-767-up 的前 slides 张）
     * @param {number} hiddenGallerySlides 橱窗中已隐藏、不计入阈值的前几张；开启 show_2_main_media_in_grid 时为 0
     */
    updateSectionFirstMediaAspectRatio(sectionVisableMediaList, hiddenGallerySlides = this.hiddenGallerySlides) {
      if (this.layoutBranch != '2') return;

      if (!this.section) return;
      this.section.style.setProperty('--media-aspect-ratio', sectionVisableMediaList[0 + hiddenGallerySlides]?.getAttribute('data-aspect-ratio') ?? '1');
      if (this.airlineCompatibilityButton) {
        sectionVisableMediaList[0 + hiddenGallerySlides]?.classList.add('product__media--current-first');
      }
    }

    /**
     * @description 当 variant 变化时，更新选项输入框的选中状态，以及更新媒体模块的媒体列表
     * @param {Event & {detail: {variant: import("@/src/types/shopify").ShopifyVariant}}} event 
     */
    onVariantChange(event) {
      const variant = event?.detail?.variant;
      if (!variant) return;

      const variantIdChanged = variant.id != this.currentVariantId;
      if (!variantIdChanged && !this._syncingToLayoutA) return;

      this.currentVariantId = variant.id;

      // B 布局是桌面端选项源；同步到 A 的过程中不要用 A 的中间态回写 B（会冲掉 rebuildOptions 自动切换的颜色）
      if (!this._syncingToLayoutA) {
        for (let i = 0; i < variant.options.length; i++) {
          const optionPosition = i + 1;
          const optionValue = variant.options[i];
          const optionInput = this.querySelector(
            `[data-option-position="${optionPosition}"] input[value="${CSS.escape(optionValue)}"]`
          );
          if (optionInput) {
            optionInput.checked = true;
          } else {
            console.warn(`Option input not found for option ${optionValue} at position ${optionPosition} in B layout content`);
          }
        }
      }

      // 双 rAF：等待 layout A 颜色分组（GroupVariantImagesByPosition）更新可见 slides 后再复制媒体
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.hanldeUpdateMedia(variant);
        });
      });
    }

    /**
     * @description 当 B 布局内的变体选项发生变化时，更新主模块另一边的选项输入框的选中状态
     * @param {Event & {target: HTMLInputElement}} event 
     */
    onOptionChange(event) {
      if (!event.target?.matches?.('input[type="radio"]')) return;
      if (!event.target.closest('[data-option-position]')) return;

      // 合并同一轮 change 链（含 rebuildOptions 自动切换颜色），最终以 B 的全部选中项一次性同步到 A
      if (this._syncOptionsRAF) cancelAnimationFrame(this._syncOptionsRAF);
      this._syncOptionsRAF = requestAnimationFrame(() => {
        this._syncOptionsRAF = null;
        this.syncAllOptionsToLayoutA();
      });
    }
  });
} 